import React from 'react';

const variants = {
    primary: 'bg-gray-900 text-white hover:bg-gray-800 border border-transparent',
    secondary: 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200',
    danger: 'bg-red-600 text-white hover:bg-red-700 border border-transparent',
    ghost: 'text-gray-600 hover:bg-gray-100 border border-transparent',
    outline: 'bg-transparent text-gray-700 hover:bg-gray-50 border border-gray-200',
};

const sizes = {
    xs: 'h-7 px-2 text-xs gap-1',
    sm: 'h-8 px-3 text-xs gap-1.5',
    md: 'h-9 px-4 text-sm gap-2',
    lg: 'h-10 px-5 text-sm gap-2',
};

export default function Button({
    children,
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled = false,
    className = '',
    icon,
    ...props
}) {
    const base = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1 disabled:opacity-50 disabled:pointer-events-none';

    return (
        <button
            className={`${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
            disabled={disabled || loading}
            {...props}
        >
            {loading && (
                <svg className="animate-spin h-3.5 w-3.5" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
            )}
            {!loading && icon}
            {children}
        </button>
    );
}
